import React, {memo, useCallback, useMemo} from 'react';
import {useHistory} from 'react-router-dom';

import './index.scss';

import weatherIcon0 from '../../assets/images/icons/header/0.svg';
import weatherIcon1 from '../../assets/images/icons/header/1.svg';
import weatherIcon2 from '../../assets/images/icons/header/2.svg';
import weatherIcon3 from '../../assets/images/icons/header/3.svg';
import weatherIcon4 from '../../assets/images/icons/header/4.svg';
import weatherIcon5 from '../../assets/images/icons/header/5.svg';
import weatherIcon6 from '../../assets/images/icons/header/6.svg';
import weatherIcon7 from '../../assets/images/icons/header/7.png';
import weatherIcon8 from '../../assets/images/icons/header/8.png';
import weatherIcon9 from '../../assets/images/icons/header/9.png';
import weatherIcon10 from '../../assets/images/icons/header/10.png';
import logo from '../../assets/images/icons/logo.png'

import {DateTime} from '../DateTime';
import {useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import { useChangeTheme } from '../../hooks/change-theme';
import { useLocalization } from '../../hooks/localization';

const weatherIcons = [
    weatherIcon0,
    weatherIcon1,
    weatherIcon2,
    weatherIcon3,
    weatherIcon4,
    weatherIcon5,
    weatherIcon6,
    weatherIcon7,
    weatherIcon8,
    weatherIcon9,
    weatherIcon10,
];

export const Header = memo(function Header({locked}: { locked: boolean }) {
    const history = useHistory();
    const [rpc] = useRPC();
    const {theme} = useChangeTheme()
    const {success} = useMessage(); 
    const {t} = useLocalization();
    // const location = useLocation();
    // const question = useQuestion();
    // const [rpc] = useRPC();
    // const dispatch = useDispatch();
    // const role = useSelector(state => state.ui.role);

    const {icon, temperature} = useSelector(state => state.temperature);

    const onClick = useCallback(() => {
        // if (role != null && role !== 'default') {
        //     e.preventDefault();
        //     if (location.pathname.includes('/settings')) {
        //         question('Çıkış yapmak ister misiniz?', () => {
        //             rpc.doLogout();
        //             dispatch(clearUserAction());
        //             removeSession();
        //             history.push('/');
        //         }, () => {
        //             history.push('/');
        //         }, {text: 'Evet', timed: false}, true);
        //         return;
        //     }
        // }

        history.push('/');
    }, [history]);

    const onDateTimeClick = useCallback(() => {
        try{
            rpc.broadcastTimeAndWeather();
            success(t("date_and_time_updated"), true)
        } catch {
        }   
    }, [rpc, success, t]);

    const onWeatherClick = useCallback(() => {
        try{
            rpc.broadcastTimeAndWeather();
            success(t("weather_updated"), true)
        } catch {
        }
    }, [rpc, success, t]);

    return (
        <div className={`header ${theme === "rounded" ? "header-options" : ""}` + (locked ? " blur" : "")}>
            <span className="logo" {...onClickHandler(onClick)}>
                <img src={logo} alt="" />
            </span>
            <div className="menu" {...onClickHandler(onWeatherClick)}>
                <div className="weather">
                    <img className="weather-icon" src={weatherIcons[icon] || weatherIcons[0]} alt="weather" />
                    <span className="weather-text">
                        {temperature.toString()} <small>°C</small>
                    </span>
                </div>
            </div>
            <div className="menu" {...onClickHandler(onDateTimeClick)}>
                <DateTime />
            </div>
        </div>
    )
});
